import { gql } from '@apollo/client'
import InternationalAddressFragment from './InternationalAddress.fragment'
// This is the same for public and resigned public profiles
export default gql`
  fragment EmployeeAddress on EmployeeAddress {
    addressId
    type
    address {
      ...InternationalAddress
    }
  }
  ${InternationalAddressFragment}
`
